import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { showToast } from '../Common/Messages';
const SearchPanel = (props) => {
    const location = useLocation();
    const history = useNavigate();
    
    const [searchText, setSearchText] = useState('');

    
    const handleChange = (e) => {
        setSearchText(e.target.value);
    }
    const handleKeyUp = (e) => {
        if(e.key == 'Enter'){
            if(searchText.trim().length > 0){
                props.panelClose()
                history('/Search', {state:searchText});
                
            }
            else
                showToast('warning', "검색어를 입력해주세요");
        }
    }

    return (
        <div className="search" ref={props.searchRef}>
            <div className='search-wrap'>
                <h2 className='search-title'>KDC 통합검색</h2>
                <div className="search-input">
                    <i className="icoKdc24 magnifier-b"></i>
                    <input placeholder="궁금한 사항을 검색해 보세요." value={searchText} onChange={(e) => handleChange(e)} onKeyUp={(e) => handleKeyUp(e)} autoFocus />
                </div>
                <div className="keywords-wrap">
                    <p className='keywords-title'>추천 검색어</p>
                    <ul className='keywords'>
                        <li onClick={(e)=> {setSearchText(e.target.innerText)}}>루아스크립트</li>
                        <li onClick={(e)=> {setSearchText(e.target.innerText)}}>JavaScript</li>
                        <li onClick={(e)=> {setSearchText(e.target.innerText)}}>프로세스</li>
                        <li onClick={(e)=> {setSearchText(e.target.innerText)}}>공통</li>
                        <li onClick={(e)=> {setSearchText(e.target.innerText)}}>규칙</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default SearchPanel;